import Vue from 'vue';
import Vuex from 'vuex';
import {getDepartmentTerminalInfoLis} from  '../api/energyMG'
import {getConfigBytype,sendMeterInfoMsg} from  '../api/payMG'
import { menu } from '../api/userMG'


Vue.use(Vuex);
function chagenData(data){
	data.forEach(item =>{
		if( item.terminalInfo){
			if(!item.deps){
				item.deps = []
			}
			item.terminalInfo.forEach(sitem => {
				let obj = {}
				obj.id = sitem.id
				obj.departmentName = sitem.terminalName
				obj.terminalCode = sitem.terminalCode
				obj.isJz= true
				item.deps.push(obj)
			})
		}

		if( item.deps){
			chagenData(item.deps)
		}
	})

	return  data
}


export default new Vuex.Store({
    state: {
    user: false,
		isRe:false,
		perms:[] ,// 用户权限标识集合
    permsMethods:[],
    menuList:[],
		depts:[],//部门和集中器列表
		energyConfig:[],//能源配置
		remind:{},
    headerCss:{background:'#79bbff',color:'#ffffff'},
    cancelRequest:null

    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            // localStorage.setItem("userInfo", user);
			sessionStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            // localStorage.setItem("userInfo", "");
			sessionStorage.setItem("userInfo", "");
			sessionStorage.setItem("userdata", "");
        },
      setPerms(state, perms){  // 用户权限标识集合
          state.perms = perms;
      },
      setPermMethods(state, perms){  // 用户权限标识集合
          state.permsMethods = perms;
      },
      setRe(state,data){
        state.isRe = data
      },
      setDepts(state,data){
        state.depts = data
      },
      setConfig( state,data ){
        state.energyConfig = data
      },
      setRemind(state,data){
        state.remind = data
      },
      setCancelRequest(state,data){
        state.cancelRequest = data
      },
      getMenus(state,data){
        state.menuList = data
      },




    },
	actions:{
		getDepts({commit}){

			if(!this.state.depts.length){

				getDepartmentTerminalInfoLis().then( res => {
					if(res.status == 1){
						let resData = chagenData(res.data.menuDepList)
						commit('setDepts',resData)
					}
				})
			}
		},
		//获取推送信息
		getSendMsg({commit}){
			sendMeterInfoMsg().then(res =>{
				if( res.status == 1 ){
					 commit('setRemind', res.data)
				}
			})
		},
		getEnergyTypeConfig({commit}){

			return new Promise((resolve,reject) => {
				if(!this.state.energyConfig.length){

					getConfigBytype({type:'energyType'}).then( res => {
						if(res.status == 1){
							commit('setConfig',res.data)
							resolve(res.data)
						}
					})
				}else{
					resolve(this.state.energyConfig)
				}
			})

		},



    getMenuList({commit}){
      return new Promise((resolve,reject) => {
        menu({ uid:JSON.parse(sessionStorage.getItem("userdata")).uid}).then(res => {
          if( res.status == 1 ){

             commit('getMenus',res.data)

             resolve(res.data)
          }else{
            reject(res.msg)
          }
        })
      })
    },
    // getPerMethods({dispatch,commit,state}){
    //   if( this.state.menuList.length){

    //   }else{
    //     dispatch('getMenuList').then(res => {

    //     })
    //   }
    // }




	}
});



// WEBPACK FOOTER //
// ./src/vuex/store.js